import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchBeaconMessageList(filter) {
  return request({
    url: '/api/beacon_messages',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function fetchBeaconMessage(id, filter) {
  return request({
    url: '/api/beacon_messages/' + id,
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createBeaconMessage(data) {
  return request({
    url: '/api/beacon_messages',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateBeaconMessage(id, data) {
  return request({
    url: '/api/beacon_messages/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function createBeaconMessageLang(data) {
  return request({
    url: '/api/beacon_message_langs',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function updateBeaconMessageLang(id, data) {
  return request({
    url: '/api/beacon_message_langs/' + id,
    method: 'patch',
    params: {
      'access_token': getToken()
    },
    data
  })
}



